/**
*  This barrel file provides the export for the lazy loaded SignupComponent.
*/
export * from './signup.component';
export * from './signup.routes';



// WEBPACK FOOTER //
// ./src/app/signup/index.ts